import React from 'react';
import { motion } from 'framer-motion';
import { personalInfo } from '../../data/portfolioData';
import styles from './About.module.css';

const fadeUpVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
};

const staggerContainer = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.1 } }
};

const About = () => {
  return (
    <section id="about" className={styles.aboutSection}>
      <div className={styles.container}>
        <motion.div 
          className={styles.contentRow}
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          {/* Left Side: Code Visual */}
          <motion.div variants={fadeUpVariants} className={styles.leftCol}>
            <div className={styles.codeCard}>
              <div className={styles.windowControls}>
                <span className={styles.redDot}></span>
                <span className={styles.yellowDot}></span>
                <span className={styles.greenDot}></span>
              </div>
              <pre className={styles.codeBlock}>
                <code>
                  <span className={styles.comment}># AI Engineer at work</span>
                  <br />
                  <span className={styles.keyword}>agent</span> = LangChain.<span className={styles.class}>Agent</span>(
                  <br />
                  &nbsp;&nbsp;llm=<span className={styles.string}>"gpt-4o"</span>,
                  <br />
                  &nbsp;&nbsp;tools=[search, calendar, crm]
                  <br />
                  )
                  <br />
                  <span className={styles.keyword}>result</span> = agent.<span className={styles.method}>run</span>(<span className={styles.string}>"automate workflow"</span>)
                </code>
              </pre>
            </div>
          </motion.div>

          {/* Right Side: Text */}
          <motion.div variants={fadeUpVariants} className={styles.rightCol}>
            <span className={styles.label}>ABOUT ME</span>
            <h2 className={styles.h2}>Building the Future with AI</h2>
            <p className={styles.bodyText}>
              {personalInfo.bio}
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
